// @flow
import axios from "axios";
import TVGConf from "@tvg/conf";
import { tvgHeaders } from "./utils";

export type idResponse = {
  error: ?{
    status: string,
    message: string
  },
  success: ?{
    status: string,
    data: {
      response: {
        data: {
          accountNumber: string
        }
      }
    }
  }
};

export const onError = () => ({
  error: {
    status: "error",
    message: "States request fail"
  },
  success: null
});

const onSuccess = (response) => ({
  error: null,
  success: {
    status: "success",
    data: {
      response
    }
  }
});

export default (): Promise<idResponse> =>
  axios({
    method: "get",
    url: `${TVGConf().config().service.usa}/session/context`,
    headers: tvgHeaders(),
    withCredentials: true
  })
    .then(onSuccess)
    .catch(onError);
